import { render, staticRenderFns } from "./Update-Sales-Summary.vue?vue&type=template&id=52207f66"
import script from "./Update-Sales-Summary.vue?vue&type=script&lang=js"
export * from "./Update-Sales-Summary.vue?vue&type=script&lang=js"
import style0 from "./Update-Sales-Summary.vue?vue&type=style&index=0&id=52207f66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports